// extracted by mini-css-extract-plugin
module.exports = {"dropzoneItem":"DropzoneItem_dropzoneItem__uY6wg","thumbnail":"DropzoneItem_thumbnail__2wOZc","loaded":"DropzoneItem_loaded__1IaAp","name":"DropzoneItem_name__2orQg"};